import React, { useEffect, useState } from 'react';
import { LocationSettings, ComplaintTatSettings } from '../../features/admin/components';
import './SettingsPage.css';

function SettingsPage({ token, locationId, user, initialExpandedCard = null }) {
  // Initialize hooks first (must be called in same order)
  const [expandedCards, setExpandedCards] = useState({
    location: false,
    complaintTat: initialExpandedCard === 'complaintTat',
  });
  const [editingCard, setEditingCard] = useState(null);

  useEffect(() => {
    if (!initialExpandedCard) return;

    setExpandedCards((prev) => ({
      ...prev,
      [initialExpandedCard]: true,
    }));

    requestAnimationFrame(() => {
      document
        .getElementById(`settings-card-${initialExpandedCard}`)
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [initialExpandedCard]);

  // Location admin Settings page
  const isAdmin = user && user.role === 'admin';
  const hasAccess = isAdmin;

  if (!hasAccess) {
    return (
      <div className="settings-page">
        <div className="settings-description-section">
          <h1>Access Denied</h1>
          <p>You do not have permission to access settings</p>
        </div>
      </div>
    );
  }

  const toggleCard = (cardId) => {
    setExpandedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  const handleEditClick = (e, cardId) => {
    e.stopPropagation(); // Prevent card collapse when clicking edit
    setEditingCard(cardId);
    setExpandedCards((prev) => ({
      ...prev,
      [cardId]: true,
    }));
  };

  const handleEditCancel = () => {
    setEditingCard(null);
  };

  return (
    <div className="settings-page">
      <div className="settings-description-section">
        <h1>⚙️ Settings</h1>
        <p>Manage your location settings</p>
      </div>

      <div className="settings-cards-grid">
        {/* Location Settings Card */}
        <div className="settings-card settings-card--full-width">
          <div className="settings-card-header" onClick={() => toggleCard('location')}>
            <div className="settings-card-header-left">
              <span className="settings-card-toggle">
                {expandedCards.location ? '▼' : '▶'}
              </span>
              <span className="settings-card-icon">🏥</span>
              <h3>Location</h3>
            </div>
            <div className="settings-card-header-right">
              <button
                type="button"
                className="action-btn action-primary"
                onClick={(e) => handleEditClick(e, 'location')}
              >
                <span className="action-icon">✏️</span>
                <span className="action-text">Edit</span>
              </button>
            </div>
          </div>
          {expandedCards.location && (
            <div className="settings-card-content">
              <LocationSettings
                token={token}
                locationId={locationId}
                isCard={true}
                isEditingProp={editingCard === 'location'}
                onEditCancel={handleEditCancel}
                currentUser={user}
              />
            </div>
          )}
        </div>

        {/* Complaint TAT — location admin configures their location */}
        {isAdmin && locationId && (
          <div
            id="settings-card-complaintTat"
            className="settings-card settings-card--full-width"
          >
            <div className="settings-card-header" onClick={() => toggleCard('complaintTat')}>
              <div className="settings-card-header-left">
                <span className="settings-card-toggle">
                  {expandedCards.complaintTat ? '▼' : '▶'}
                </span>
                <span className="settings-card-icon">⏱️</span>
                <h3>Complaint TAT</h3>
              </div>
              <div className="settings-card-header-right" aria-hidden="true" />
            </div>
            {expandedCards.complaintTat && (
              <div className="settings-card-content">
                <ComplaintTatSettings token={token} locationId={locationId} />
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}

export default SettingsPage;
